import React from "react";

const Number: React.FC<{
  num: number | void;
  defaultOutput?: string;
  shouldAbbreviate?: boolean;
}> = ({ num, defaultOutput = "", shouldAbbreviate = false }) => (
  <>
    {num != null
      ? window.tcbase.formatNumber(num, shouldAbbreviate)
      : defaultOutput}
  </>
);

export default Number;
